import { render, staticRenderFns } from "./RedirectForm.vue?vue&type=template&id=c0258728&scoped=true&"
import script from "./RedirectForm.vue?vue&type=script&lang=js&"
export * from "./RedirectForm.vue?vue&type=script&lang=js&"
import style0 from "./RedirectForm.vue?vue&type=style&index=0&id=c0258728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0258728",
  null
  
)

export default component.exports